import { Box, Typography } from "@mui/material";

function WeeklyDayPicker(props) {
  const { day, setDay } = props;
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="subtitle1" color="grey.3" align="center">
        در کدام روز از هفته می‌خواهید پس‌انداز خودکار انجام شود؟
      </Typography>
      <Box
        sx={{
          mt: "12px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {[
          { title: "شنبه", value: 6 },
          { title: "یک‌شنبه", value: 7 },
          { title: "دوشنبه", value: 1 },
          { title: "سه‌شنبه", value: 2 },
          { title: "چهار‌شنبه", value: 3 },
          { title: "پنج‌شنبه", value: 4 },
          { title: "جمعه", value: 5 },
        ].map((item) => {
          const isActive = day === item.value;
          return (
            <Box
              onClick={() => {
                setDay(item.value);
              }}
              sx={{
                my: "8px",
                mx: "4px",
                flexBasis: "30%",
                minHeight: 36,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "36px",
                bgcolor: isActive ? "primary.main" : "common.white",
                border: (theme) => `1px solid ${theme.palette.grey[5]}`,
              }}
            >
              <Typography
                variant="body2"
                color={isActive ? "common.white" : "grey.2"}
              >
                {item.title}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default WeeklyDayPicker;
